import { render, staticRenderFns } from "./saleInvoicesList.vue?vue&type=template&id=82648f56&scoped=true"
import script from "./saleInvoicesList.vue?vue&type=script&lang=js"
export * from "./saleInvoicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82648f56",
  null
  
)

export default component.exports